module.exports = __webpack_public_path__ + "img/1_no.565334f0.svg";